import styled from "styled-components";

import "react-sliding-pane/dist/react-sliding-pane.css";

//Table
export const WorkersTableContainer = styled.div``;
